import { render, staticRenderFns } from "./CardHolder.vue?vue&type=template&id=f1e9696a"
import script from "./CardHolder.vue?vue&type=script&lang=js"
export * from "./CardHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports